import {USER_PROFILE} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/phone'
import {push} from 'react-router-redux'
import {endpoint as endpointText} from '../../../common/text'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class missingInfoPhone {

  static setTab(tab) {
    return {
      type: types.SET_TAB,
      payload: {
        tab,
      }
    }
  }

  static setPhoneNumber(value) {
    return {
      type: types.SET_PHONE_NUMBER,
      payload: {
        value,
      }
    }
  }

  static sendSMS() {
    return function(dispatch, getState) {

      const state = getState().ui.missingInfo.phone
      const phone = state.getIn(['number', 'value'])

      if (phone === '') {
        dispatch(missingInfoPhone.sendSMSFail(''))
        return Promise.reject(null)
      }

      dispatch({type: types.SEND_SMS})

      const data = new FormData()
      data.append('phone_number', "+54" + phone)

      return apiPrivate.post(USER_PROFILE + '/user/phone/verificationSMS', data)
        .then(response => {
          dispatch(missingInfoPhone.sendSMSSuccess())
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(missingInfoPhone.sendSMSFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(missingInfoPhone.sendSMSFail(message))
        })
    }
  }

  static sendSMSSuccess() {
    return {
      type: types.SEND_SMS_SUCCESS,
    }
  }

  static sendSMSFail(error) {
    return {
      type: types.SEND_SMS_FAIL,
      payload: {
        error,
      },
    }
  }

  static setCode(value) {
    return {
      type: types.SET_CODE,
      payload: {
        value,
      }
    }
  }

  static confirm() {
    return function(dispatch, getState) {

      const state = getState().ui.missingInfo.phone
      const code = state.getIn(['code', 'value'])

      if (code === '') {
        dispatch(missingInfoPhone.confirmFail(''))
        return Promise.reject(null)
      }

      dispatch({type: types.CONFIRM})

      const data = new FormData()
      data.append('code', code)

      return apiPrivate.post(USER_PROFILE + '/user/phone', data)
        .then(response => {
          dispatch(missingInfoPhone.confirmSuccess())
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(missingInfoPhone.confirmFail(message))
              return Promise.reject(null)
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(missingInfoPhone.confirmFail(message))
          return Promise.reject(null)
        })
    }
  }

  static confirmSuccess() {
    return {
      type: types.CONFIRM_SUCCESS,
    }
  }

  static confirmFail(error) {
    return {
      type: types.CONFIRM_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/missingInfo/actions/phone.js